module.exports = __webpack_public_path__ + "img/icon-users.2aefad4.svg";